// Generated from legacy db.ts to keep files under 500 lines.
import { sql } from "../../base";
import type { MatterType } from "../../types";

const matterTypesModule = {
  async findByUserId(userId: string, activeOnly: boolean = true): Promise<MatterType[]> {
    try {
      const result = activeOnly
        ? await sql`
            SELECT * FROM matter_types
            WHERE user_id = ${userId} AND is_active = true
            ORDER BY position ASC, name ASC
          `
        : await sql`
            SELECT * FROM matter_types
            WHERE user_id = ${userId}
            ORDER BY position ASC, name ASC
          `;
      return (result || []) as MatterType[];
    } catch (error) {
      console.error('Error fetching matter types:', error);
      return [];
    }
  },
  
  async findById(id: string, userId: string): Promise<MatterType | null> {
    try {
      const result = await sql`
        SELECT * FROM matter_types
        WHERE id = ${id} AND user_id = ${userId}
        LIMIT 1
      `;
      return result[0] as MatterType || null;
    } catch (error) {
      console.error('Error fetching matter type:', error);
      return null;
    }
  },
  
  async create(data: Omit<MatterType, 'id' | 'created_at' | 'updated_at'>): Promise<MatterType> {
    const result = await sql`
      INSERT INTO matter_types (user_id, name, description, color, position, is_active)
      VALUES (${data.user_id}, ${data.name}, ${data.description}, ${data.color}, 
              ${data.position}, ${data.is_active !== false})
      RETURNING *
    `;
    return result[0] as MatterType;
  },
  
  async update(id: string, userId: string, data: Partial<MatterType>): Promise<MatterType> {
    const result = await sql`
      UPDATE matter_types
      SET name = COALESCE(${data.name}, name),
          description = COALESCE(${data.description}, description),
          color = COALESCE(${data.color}, color),
          position = COALESCE(${data.position}, position),
          is_active = COALESCE(${data.is_active}, is_active),
          updated_at = now()
      WHERE id = ${id} AND user_id = ${userId}
      RETURNING *
    `;
    return result[0] as MatterType;
  },
  
  async delete(id: string, userId: string): Promise<boolean> {
    const result = await sql`
      DELETE FROM matter_types
      WHERE id = ${id} AND user_id = ${userId}
    `;
    return result.count > 0;
  }
};

export type MatterTypesModule = typeof matterTypesModule;

export function registerMatterTypes(db: { matterTypes?: MatterTypesModule }) {
  db.matterTypes = matterTypesModule;
}

export { matterTypesModule as matterTypes };
